// removed by extract-text-webpack-plugin
module.exports = {"header":"reviewer-summary__header___2Ps8v","treatmentStatus":"reviewer-summary__treatmentStatus___20lgl","treatmentActive":"reviewer-summary__treatmentActive___2IB4Y","treatmentInactive":"reviewer-summary__treatmentInactive___LqRSQ"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/reviewers/reviewer-summary.css
// module id = 1215
// module chunks = 0